import React from 'react';

function getJobLocationData(jobData) {
  let location = null;

  if (jobData.BlueXJobData.City && jobData.BlueXJobData.Region) {
    location = `${jobData.BlueXJobData.City}, ${jobData.BlueXJobData.Region}`;
  } else if (jobData.BlueXJobData.Region) {
    location = jobData.BlueXJobData.Region;
  } else if (jobData.BlueXJobData.City) {
    location = jobData.BlueXJobData.City;
  }

  return location;
}

export default getJobLocationData;
